export default __webpack_public_path__ + "static/comming-for-2-03aa16982abb0a871bb317a69442bc25.png";